export const countryList = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Réunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Wallis and Futuna",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
export const ageList = ["18", "19", "20", "21", "22", "23", "24", "25", "26+"];
// here  
export const operationHours = [
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
];
//00:00 to 23:45) in 15-minute intervals 
export const defaultOperationHours = Array.from({ length: 96 }, (_, i) => {
  const hours = String(Math.floor(i / 4)).padStart(2, "0");
  const minutes = String((i % 4) * 15).padStart(2, "0");
  return `${hours}:${minutes}`;
});

export const emailRegex = RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
export const phoneRegex = RegExp(/^(\+?6?01)[02-46-9]-*[0-9]{7}$|^(\+?6?01)[1]-*[0-9]{8}$/);

// Age validation constants
export const MINIMUM_DRIVER_AGE = 18; // Configurable minimum age for car rental


export const MAX_CHARGE_DAYS: Record<string, number> = {
  NVS: 10, // GPS Navigation 
  BSEAT: 10, //BABY SAFETY SEAT(0-12 MONTHS)
  CSEAT: 10, //CHILD SEAT
  YDS: 4,  //YOUNG DRIVER SURCHARGE
};

export const HIDDEN_EXTRA_ITEMS: string[] = [
  "YDS",  //YOUNG DRIVER SURCHARGE
  "APTCO",
  "APTDE",
  "AHOUC",  //AFTER HOUR COLLECTION
  "AHOUR", //AFTER HOURS DELIVERY
  "OW", //One way
];

export const ONE_TIME_CHARGE_EXTRA_ITEMS: string[] = [
  "OW", //One way
  "APTCO",
  "APTDE",
  "AHOUC", //AFTER HOUR COLLECTION
  "AHOUR",//AFTER HOURS DELIVERY
  "LLP", //LEGAL LIABILITY PASSENGER
];

export const countryPhoneCodes = [
  { "country": "Afghanistan", "code": "+93", "iso": "AF" },
  { "country": "Albania", "code": "+355", "iso": "AL" },
  { "country": "Algeria", "code": "+213", "iso": "DZ" },
  { "country": "Andorra", "code": "+376", "iso": "AD" },
  { "country": "Angola", "code": "+244", "iso": "AO" },
  { "country": "Antigua and Barbuda", "code": "+1", "iso": "AG" },
  { "country": "Argentina", "code": "+54", "iso": "AR" },
  { "country": "Armenia", "code": "+374", "iso": "AM" },
  { "country": "Aruba", "code": "+297", "iso": "AW" },
  { "country": "Australia", "code": "+61", "iso": "AU" },
  { "country": "Austria", "code": "+43", "iso": "AT" },
  { "country": "Azerbaijan", "code": "+994", "iso": "AZ" },
  { "country": "Bahamas", "code": "+1", "iso": "BS" },
  { "country": "Bahrain", "code": "+973", "iso": "BH" },
  { "country": "Bangladesh", "code": "+880", "iso": "BD" },
  { "country": "Barbados", "code": "+1", "iso": "BB" },
  { "country": "Belarus", "code": "+375", "iso": "BY" },
  { "country": "Belgium", "code": "+32", "iso": "BE" },
  { "country": "Belize", "code": "+501", "iso": "BZ" },
  { "country": "Benin", "code": "+229", "iso": "BJ" },
  { "country": "Bhutan", "code": "+975", "iso": "BT" },
  { "country": "Bolivia", "code": "+591", "iso": "BO" },
  { "country": "Bosnia and Herzegovina", "code": "+387", "iso": "BA" },
  { "country": "Botswana", "code": "+267", "iso": "BW" },
  { "country": "Brazil", "code": "+55", "iso": "BR" },
  { "country": "Brunei", "code": "+673", "iso": "BN" },
  { "country": "Bulgaria", "code": "+359", "iso": "BG" },
  { "country": "Burkina Faso", "code": "+226", "iso": "BF" },
  { "country": "Burundi", "code": "+257", "iso": "BI" },
  { "country": "Cambodia", "code": "+855", "iso": "KH" },
  { "country": "Cameroon", "code": "+237", "iso": "CM" },
  { "country": "Canada", "code": "+1", "iso": "CA" },
  { "country": "Cape Verde", "code": "+238", "iso": "CV" },
  { "country": "Central African Republic", "code": "+236", "iso": "CF" },
  { "country": "Chad", "code": "+235", "iso": "TD" },
  { "country": "Chile", "code": "+56", "iso": "CL" },
  { "country": "China", "code": "+86", "iso": "CN" },
  { "country": "Colombia", "code": "+57", "iso": "CO" },
  { "country": "Comoros", "code": "+269", "iso": "KM" },
  { "country": "Congo", "code": "+242", "iso": "CG" },
  { "country": "Cook Islands", "code": "+682", "iso": "CK" },
  { "country": "Costa Rica", "code": "+506", "iso": "CR" },
  { "country": "Côte d'Ivoire", "code": "+225", "iso": "CI" },
  { "country": "Croatia", "code": "+385", "iso": "HR" },
  { "country": "Cuba", "code": "+53", "iso": "CU" },
  { "country": "Curaçao", "code": "+599", "iso": "CW" },
  { "country": "Cyprus", "code": "+357", "iso": "CY" },
  { "country": "Czech Republic", "code": "+420", "iso": "CZ" },
  { "country": "Democratic Republic of the Congo", "code": "+243", "iso": "CD" },
  { "country": "Denmark", "code": "+45", "iso": "DK" },
  { "country": "Djibouti", "code": "+253", "iso": "DJ" },
  { "country": "Dominica", "code": "+1", "iso": "DM" },
  { "country": "Dominican Republic", "code": "+1", "iso": "DO" },
  { "country": "East Timor", "code": "+670", "iso": "TL" },
  { "country": "Ecuador", "code": "+593", "iso": "EC" },
  { "country": "Egypt", "code": "+20", "iso": "EG" },
  { "country": "El Salvador", "code": "+503", "iso": "SV" },
  { "country": "Equatorial Guinea", "code": "+240", "iso": "GQ" },
  { "country": "Eritrea", "code": "+291", "iso": "ER" },
  { "country": "Estonia", "code": "+372", "iso": "EE" },
  { "country": "Eswatini", "code": "+268", "iso": "SZ" }, // Added Eswatini code, was missing
  { "country": "Ethiopia", "code": "+251", "iso": "ET" },
  { "country": "Falkland Islands", "code": "+500", "iso": "FK" },
  { "country": "Faroe Islands", "code": "+298", "iso": "FO" },
  { "country": "Fiji", "code": "+679", "iso": "FJ" },
  { "country": "Finland", "code": "+358", "iso": "FI" },
  { "country": "France", "code": "+33", "iso": "FR" },
  { "country": "French Guiana", "code": "+594", "iso": "GF" },
  { "country": "French Polynesia", "code": "+689", "iso": "PF" },
  { "country": "Gabon", "code": "+241", "iso": "GA" },
  { "country": "Gambia", "code": "+220", "iso": "GM" },
  { "country": "Georgia", "code": "+995", "iso": "GE" },
  { "country": "Germany", "code": "+49", "iso": "DE" },
  { "country": "Ghana", "code": "+233", "iso": "GH" },
  { "country": "Gibraltar", "code": "+350", "iso": "GI" },
  { "country": "Greece", "code": "+30", "iso": "GR" },
  { "country": "Greenland", "code": "+299", "iso": "GL" },
  { "country": "Grenada", "code": "+1", "iso": "GD" },
  { "country": "Guadeloupe", "code": "+590", "iso": "GP" },
  { "country": "Guatemala", "code": "+502", "iso": "GT" },
  { "country": "Guinea", "code": "+224", "iso": "GN" },
  { "country": "Guinea-Bissau", "code": "+245", "iso": "GW" },
  { "country": "Guyana", "code": "+592", "iso": "GY" },
  { "country": "Haiti", "code": "+509", "iso": "HT" },
  { "country": "Honduras", "code": "+504", "iso": "HN" },
  { "country": "Hong Kong", "code": "+852", "iso": "HK" },
  { "country": "Hungary", "code": "+36", "iso": "HU" },
  { "country": "Iceland", "code": "+354", "iso": "IS" },
  { "country": "India", "code": "+91", "iso": "IN" },
  { "country": "Indonesia", "code": "+62", "iso": "ID" },
  { "country": "Iran", "code": "+98", "iso": "IR" },
  { "country": "Iraq", "code": "+964", "iso": "IQ" },
  { "country": "Ireland", "code": "+353", "iso": "IE" },
  { "country": "Israel", "code": "+972", "iso": "IL" },
  { "country": "Italy", "code": "+39", "iso": "IT" },
  { "country": "Jamaica", "code": "+1", "iso": "JM" },
  { "country": "Japan", "code": "+81", "iso": "JP" },
  { "country": "Jordan", "code": "+962", "iso": "JO" },
  { "country": "Kazakhstan", "code": "+7", "iso": "KZ" },
  { "country": "Kenya", "code": "+254", "iso": "KE" },
  { "country": "Kiribati", "code": "+686", "iso": "KI" },
  { "country": "Kosovo", "code": "+383", "iso": "XK" }, // Kosovo uses user-assigned ISO code XK
  { "country": "Kuwait", "code": "+965", "iso": "KW" },
  { "country": "Kyrgyzstan", "code": "+996", "iso": "KG" },
  { "country": "Laos", "code": "+856", "iso": "LA" },
  { "country": "Latvia", "code": "+371", "iso": "LV" },
  { "country": "Lebanon", "code": "+961", "iso": "LB" },
  { "country": "Lesotho", "code": "+266", "iso": "LS" },
  { "country": "Liberia", "code": "+231", "iso": "LR" },
  { "country": "Libya", "code": "+218", "iso": "LY" },
  { "country": "Liechtenstein", "code": "+423", "iso": "LI" },
  { "country": "Lithuania", "code": "+370", "iso": "LT" },
  { "country": "Luxembourg", "code": "+352", "iso": "LU" },
  { "country": "Macau", "code": "+853", "iso": "MO" },
  { "country": "Madagascar", "code": "+261", "iso": "MG" },
  { "country": "Malawi", "code": "+265", "iso": "MW" },
  { "country": "Malaysia", "code": "+60", "iso": "MY" },
  { "country": "Maldives", "code": "+960", "iso": "MV" },
  { "country": "Mali", "code": "+223", "iso": "ML" },
  { "country": "Malta", "code": "+356", "iso": "MT" },
  { "country": "Marshall Islands", "code": "+692", "iso": "MH" },
  { "country": "Martinique", "code": "+596", "iso": "MQ" },
  { "country": "Mauritania", "code": "+222", "iso": "MR" },
  { "country": "Mauritius", "code": "+230", "iso": "MU" },
  { "country": "Mexico", "code": "+52", "iso": "MX" },
  { "country": "Micronesia", "code": "+691", "iso": "FM" },
  { "country": "Moldova", "code": "+373", "iso": "MD" },
  { "country": "Monaco", "code": "+377", "iso": "MC" },
  { "country": "Mongolia", "code": "+976", "iso": "MN" },
  { "country": "Montenegro", "code": "+382", "iso": "ME" },
  { "country": "Morocco", "code": "+212", "iso": "MA" },
  { "country": "Mozambique", "code": "+258", "iso": "MZ" },
  { "country": "Myanmar", "code": "+95", "iso": "MM" },
  { "country": "Namibia", "code": "+264", "iso": "NA" },
  { "country": "Nauru", "code": "+674", "iso": "NR" },
  { "country": "Nepal", "code": "+977", "iso": "NP" },
  { "country": "Netherlands", "code": "+31", "iso": "NL" },
  { "country": "New Caledonia", "code": "+687", "iso": "NC" },
  { "country": "New Zealand", "code": "+64", "iso": "NZ" },
  { "country": "Nicaragua", "code": "+505", "iso": "NI" },
  { "country": "Niger", "code": "+227", "iso": "NE" },
  { "country": "Nigeria", "code": "+234", "iso": "NG" },
  { "country": "Niue", "code": "+683", "iso": "NU" },
  { "country": "Norfolk Island", "code": "+672", "iso": "NF" },
  { "country": "North Korea", "code": "+850", "iso": "KP" },
  { "country": "North Macedonia", "code": "+389", "iso": "MK" },
  { "country": "Norway", "code": "+47", "iso": "NO" },
  { "country": "Oman", "code": "+968", "iso": "OM" },
  { "country": "Pakistan", "code": "+92", "iso": "PK" },
  { "country": "Palau", "code": "+680", "iso": "PW" },
  { "country": "Palestine", "code": "+970", "iso": "PS" },
  { "country": "Panama", "code": "+507", "iso": "PA" },
  { "country": "Papua New Guinea", "code": "+675", "iso": "PG" },
  { "country": "Paraguay", "code": "+595", "iso": "PY" },
  { "country": "Peru", "code": "+51", "iso": "PE" },
  { "country": "Philippines", "code": "+63", "iso": "PH" },
  { "country": "Poland", "code": "+48", "iso": "PL" },
  { "country": "Portugal", "code": "+351", "iso": "PT" },
  { "country": "Qatar", "code": "+974", "iso": "QA" },
  { "country": "Réunion", "code": "+262", "iso": "RE" },
  { "country": "Romania", "code": "+40", "iso": "RO" },
  { "country": "Russia", "code": "+7", "iso": "RU" },
  { "country": "Rwanda", "code": "+250", "iso": "RW" },
  { "country": "Saint Kitts and Nevis", "code": "+1", "iso": "KN" },
  { "country": "Saint Lucia", "code": "+1", "iso": "LC" },
  { "country": "Saint Pierre and Miquelon", "code": "+508", "iso": "PM" },
  { "country": "Saint Vincent and the Grenadines", "code": "+1", "iso": "VC" },
  { "country": "Samoa", "code": "+685", "iso": "WS" },
  { "country": "San Marino", "code": "+378", "iso": "SM" },
  { "country": "Sao Tome and Principe", "code": "+239", "iso": "ST" },
  { "country": "Saudi Arabia", "code": "+966", "iso": "SA" },
  { "country": "Senegal", "code": "+221", "iso": "SN" },
  { "country": "Serbia", "code": "+381", "iso": "RS" },
  { "country": "Seychelles", "code": "+248", "iso": "SC" },
  { "country": "Sierra Leone", "code": "+232", "iso": "SL" },
  { "country": "Singapore", "code": "+65", "iso": "SG" },
  { "country": "Slovakia", "code": "+421", "iso": "SK" },
  { "country": "Slovenia", "code": "+386", "iso": "SI" },
  { "country": "Solomon Islands", "code": "+677", "iso": "SB" },
  { "country": "Somalia", "code": "+252", "iso": "SO" },
  { "country": "South Africa", "code": "+27", "iso": "ZA" },
  { "country": "South Korea", "code": "+82", "iso": "KR" },
  { "country": "South Sudan", "code": "+211", "iso": "SS" },
  { "country": "Spain", "code": "+34", "iso": "ES" },
  { "country": "Sri Lanka", "code": "+94", "iso": "LK" },
  { "country": "Sudan", "code": "+249", "iso": "SD" },
  { "country": "Suriname", "code": "+597", "iso": "SR" },
  { "country": "Sweden", "code": "+46", "iso": "SE" },
  { "country": "Switzerland", "code": "+41", "iso": "CH" },
  { "country": "Syria", "code": "+963", "iso": "SY" },
  { "country": "Taiwan", "code": "+886", "iso": "TW" },
  { "country": "Tajikistan", "code": "+992", "iso": "TJ" },
  { "country": "Tanzania", "code": "+255", "iso": "TZ" },
  { "country": "Thailand", "code": "+66", "iso": "TH" },
  { "country": "Togo", "code": "+228", "iso": "TG" },
  { "country": "Tokelau", "code": "+690", "iso": "TK" },
  { "country": "Tonga", "code": "+676", "iso": "TO" },
  { "country": "Trinidad and Tobago", "code": "+1", "iso": "TT" },
  { "country": "Tunisia", "code": "+216", "iso": "TN" },
  { "country": "Turkey", "code": "+90", "iso": "TR" },
  { "country": "Turkmenistan", "code": "+993", "iso": "TM" },
  { "country": "Tuvalu", "code": "+688", "iso": "TV" },
  { "country": "Uganda", "code": "+256", "iso": "UG" },
  { "country": "Ukraine", "code": "+380", "iso": "UA" },
  { "country": "United Arab Emirates", "code": "+971", "iso": "AE" },
  { "country": "United Kingdom", "code": "+44", "iso": "GB" },
  { "country": "United States", "code": "+1", "iso": "US" },
  { "country": "Uruguay", "code": "+598", "iso": "UY" },
  { "country": "Uzbekistan", "code": "+998", "iso": "UZ" },
  { "country": "Vanuatu", "code": "+678", "iso": "VU" },
  { "country": "Vatican City", "code": "+379", "iso": "VA" }, // Vatican uses +379, though +39 (Italy) often works
  { "country": "Venezuela", "code": "+58", "iso": "VE" },
  { "country": "Vietnam", "code": "+84", "iso": "VN" },
  { "country": "Wallis and Futuna", "code": "+681", "iso": "WF" },
  { "country": "Yemen", "code": "+967", "iso": "YE" },
  { "country": "Zambia", "code": "+260", "iso": "ZM" },
  { "country": "Zimbabwe", "code": "+263", "iso": "ZW" }
].sort((a, b) => a.iso.localeCompare(b.iso));
